// Animation Math functions
import { CMath } from './CMath.model';

const cMath: CMath = new CMath();
cMath.linearTween = (t, b, c, d) => c * t / d + b;
cMath.easeInQuad = (t, b, c, d) => {
    t /= d;
    return c * t * t + b;
};
cMath.easeOutQuad = (t, b, c, d) => {
    t /= d;
    return -c * t * (t - 2) + b;
};
cMath.easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};
cMath.easeInCubic = (t, b, c, d) => {
    t /= d;
    return c * t * t * t + b;
};
cMath.easeOutCubic = (t, b, c, d) => {
    t /= d;
    t--;
    return c * (t * t * t + 1) + b;
};
cMath.easeInOutCubic = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t * t + b;
    }
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
};
cMath.easeInQuart = (t, b, c, d) => {
    t /= d;
    return c * t * t * t * t + b;
};
cMath.easeOutQuart = (t, b, c, d) => {
    t /= d;
    t--;
    return -c * (t * t * t * t - 1) + b;
};
cMath.easeInOutQuart = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t * t * t + b;
    }
    t -= 2;
    return -c / 2 * (t * t * t * t - 2) + b;
};
cMath.easeInQuint = (t, b, c, d) => {
    t /= d;
    return c * t * t * t * t * t + b;
};
cMath.easeOutQuint = (t, b, c, d) => {
    t /= d;
    t--;
    return c * (t * t * t * t * t + 1) + b;
};
cMath.easeInOutQuint = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t * t * t * t + b;
    }
    t -= 2;
    return c / 2 * (t * t * t * t * t + 2) + b;
};
cMath.easeInSine = (t, b, c, d) => -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
cMath.easeOutSine = (t, b, c, d) => c * Math.sin(t / d * (Math.PI / 2)) + b;
cMath.easeInOutSine = (t, b, c, d) => -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
cMath.easeInExpo = (t, b, c, d) => c * Math.pow(2, 10 * (t / d - 1)) + b;
cMath.easeOutExpo = (t, b, c, d) => c * (-Math.pow(2, -10 * t / d) + 1) + b;
cMath.easeInOutExpo = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    }
    t--;
    return c / 2 * (-Math.pow(2, -10 * t) + 2) + b;
};
cMath.easeInCirc = (t, b, c, d) => {
    t /= d;
    return -c * (Math.sqrt(1 - t * t) - 1) + b;
};
cMath.easeOutCirc = (t, b, c, d) => {
    t /= d;
    t--;
    return c * Math.sqrt(1 - t * t) + b;
};
cMath.easeInOutCirc = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
        return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    }
    t -= 2;
    return c / 2 * (Math.sqrt(1 - t * t) + 1) + b;
};
export const match: CMath = cMath;
